import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-10 md:py-16 bg-navy-900 text-white" data-id="element-130">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-131">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex flex-col items-center" data-id="element-132">
          <ShieldCheck className="w-14 h-14 md:w-20 md:h-20 text-optic mb-4 md:mb-6" data-id="element-133" />
          <h2 className="text-xl md:text-4xl font-display mb-4 md:mb-6 uppercase" data-id="element-134">
            GARANTÍA MEGAPACK TENIS RESUELTO — 7 DÍAS
          </h2>

          <div className="text-base md:text-xl text-gray-300 space-y-1.5 md:space-y-2 mb-6 md:mb-8 font-medium" data-id="element-135">
            <p data-id="element-136">Abrís los 6 tomos. Revisás los 6 bonos.</p>
            <p data-id="element-137">Los usás en tu clase si querés.</p>
            <p className="text-white font-bold mt-3 md:mt-4" data-id="element-138">
              Si en 7 días no es lo que esperabas:
            </p>
            <p className="text-optic font-display text-xl md:text-2xl" data-id="element-139">
              Te devolvemos el 100%.
            </p>
            <p data-id="element-140">Sin preguntas. Sin formularios. Sin drama.</p>
          </div>

          <p className="text-gray-400 max-w-2xl mx-auto text-xs md:text-base" data-id="element-141">
            La confianza que tenemos en el MEGAPACK TENIS RESUELTO nos permite
            hacer esa promesa sin dudar. Más de 500 entrenadores de tenis de
            todo el país ya lo saben.
          </p>

          <div className="mt-6 md:mt-8 inline-block border border-white/20 rounded-full px-4 md:px-6 py-1.5 md:py-2 text-xs md:text-sm font-bold text-gray-300 uppercase tracking-wide" data-id="element-142">
            La tasa de devoluciones es menor al 1%
          </div>
        </motion.div>
      </div>
    </section>;
}